import { render } from "./ResetPin.vue?vue&type=template&id=c1fa44ac"
import script from "./ResetPin.vue?vue&type=script&lang=js"
export * from "./ResetPin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__